<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
//import NumberInputSpinner from "vue-number-input-spinner";
import Swal from "sweetalert2";
import axios from 'axios';

import {
  required,
  requiredIf,
  email,
  sameAs,
  minLength,
  maxLength,
  //minValue,
  //maxValue,
  //numeric,
  //url,
  //alphaNum
} from "vuelidate/lib/validators";

/**
 * Form validation component
 */
export default {
  page: {
    title: "Registro de Usuario",
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: { Layout, PageHeader },
  props:{
    id:[Number,null],
  },
  data() {
    return {
      title: "Registro de Usuario",
      items: [
        {
          text: "Company",
          href: "/"
        },
        {
          text: "Users",
          href: "/company/users"
        },
        {
          text: "User",
          active: true
        }
      ],
      form: {
        id_company:           "",
        id_employee:          "",
        id_role:              "",
        de_email:             "",
        de_password:          "",
        de_rePassword:        "",
      },
      submitted: false,
      employees: [],
      roles: [],

      tableData: [],
      tableName: "",
      totalRows: 1,
      currentPage: 1,
      perPage: 100,
      pageOptions: [100],
      filter: null,
      filterOn: [],
      sortBy: "id_company",
      sortDesc: false,
      selectMode: 'single',
      fields: [],
      selected: [],
      okPassword:true,
      changePass: false,
    };
  },
  computed: {
    /**
     * Total no. of records
     */
    rows() {
      return this.tableData.length;
    }
  },
  validations: {
    form: {
      id_company:             { required: requiredIf(function(){return !this.$route.params.id;}) },
      id_employee:            { required },
      id_role:                { required },
      de_email:               { required, email },
      de_password:            {
        required: requiredIf(function(){return !this.$route.params.id;}),
        minLength: minLength(5),
        maxLength: maxLength(16),
      },
      de_rePassword:          { required: requiredIf(function(){return !this.$route.params.id;}), sameAsPassword: sameAs("de_password") },
    }
  },
  watch:{},
  created(){
    if(localStorage){
      this.user = JSON.parse( localStorage.getItem('user') );
    }
  },
  mounted() {
    // Set the initial number of items
    this.totalRows  = this.items.length;

    this.getRoles();

    if( this.$route.params.id ){
      this.getUser();
    }else{
      this.getFields();
      this.getEmployeesWithoutUser();
    }

    this.items = [];
  },
  methods: {
    async getRoles(){
      Swal.fire({
        title: "Cargando roles.",
        showConfirmButton:false,
        onBeforeOpen: () => {
          Swal.showLoading();
        }
      });
      let app = this;
      axios
      .get(
        window.serverPath+'dist/mvw/controllers/users.php',
        {
          params: {
            request: 'getUsersRoles',
            token: this.user.token
          }
        }
      )
      .then(response => {
        if( response.status == 200 ){
          app.roles = response.data;
          
          Swal.close();
        }else{
          Swal.fire("Ooops!", "No fue posible cargar los roles! Por favor cargue este módulo de nuevo.", "error");
        }
      });
    },
    async getFields(){
      let app = this;
      axios
      .get(
        window.serverPath+'dist/mvw/controllers/employees.php',
        {
          params: {
            request: 'getFields',
            token: this.user.token
          }
        }
      )
      .then(response => {
        if( response.status == 200 ){
          app.fields = response.data;
          app.sortBy = response.data[0].key;
        }else{
          Swal.fire("Ooops!", "No fue posible cargar la información! Por favor cargue este módulo de nuevo.", "error");
        }
      }).catch(e =>{
        Swal.close();
        if( e.response.status == 500){ app.$router.push({ name: 'Error-500' }); }
        if( e.response.status == 404){ app.$router.push({ name: 'Error-404' }); }
      });
    },
    async getEmployeesWithoutUser(){
      Swal.fire({
        title: "Cargando empleados.",
        showConfirmButton:false,
        onBeforeOpen: () => {
          Swal.showLoading();
        }
      });

      axios
      .get(
        window.serverPath+'dist/mvw/controllers/employees.php',
        {
          params: {
            request: 'getEmployeesWithoutUser',
            token: this.user.token
          }
        }
      )
      .then(response => {
        if( response.status == 200 ){
          this.tableData = response.data;
          
          Swal.close();
        }else{
          Swal.fire("Ooops!", "No fue posible cargar los empleados! Por favor cargue este módulo de nuevo..", "error");
        }
      });
    },
    async getUser(){
      Swal.fire({
        title: "Cargando información de usuario.",
        showConfirmButton:false,
        onBeforeOpen: () => {
          Swal.showLoading();
        }
      });
      let app = this;
      axios
      .get(
        window.serverPath+'dist/mvw/controllers/users.php',
        {
          params: {
            request: 'getUser',
            id: this.$route.params.id,
            token: this.user.token
          }
        }
      )
      .then(response => {
        if( response.status == 200 ){
          app.user = response.data;

          this.form.id_role         = app.user.id_role;
          this.form.id_company      = app.user.id_company;
          this.form.id_employee     = app.user.id_employee;
          this.form.id_user         = app.user.id_user;
          this.form.de_email        = app.user.de_email;

          Swal.close();
        }else{
          Swal.fire("Ooops!", "No fue posible cargar la información del usuario! Por favor cargue este módulo de nuevo.", "error");
        }
      });
    },

    // eslint-disable-next-line no-unused-vars
    saveUser(e) {
      let app = this;

      this.submitted = true;
      // stop here if form is invalid
      this.$v.$touch();
      
      if( !this.$v.form.$error && this.okPassword ){
        Swal.fire({
          title: "Guardando información.",
          showConfirmButton:false,
          onBeforeOpen: () => {
            Swal.showLoading();
          }
        });

        axios.post(window.serverPath+'dist/mvw/controllers/users.php', {
          request: 'saveUser',
          data: this.form,
          token: this.user.token
        })
        .then(function (response) {
          let action = "";
          if( response.data === "OK" ){
            action = "guardada";
          }
          if( response.data === "UPDATED" ){
            action = "actualizada";
          }

          Swal.fire("Buen trabajo!", "La información del usuario fue "+action+" correctamente!", "success");
          app.$router.push({ name: 'users' });
        })
        .catch(function (error) {
          Swal.fire("Ooops!" + error.message, "Al parecer ocurrió un error, por favor intente de nuevo.", "error");
        });
      }else{
        console.log
      }
    },

    /**
     * Search the table data with search input
     */
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    onRowSelected(item) {
      console.log(item[0]);
      if(item.length == 0){
        this.form.id_company  = "";
        this.form.de_email    = "";
        this.form.id_employee = "";
      }else{
        this.form.id_company  = item[0].id_company;
        this.form.id_employee = item[0].id_employee;
        this.form.de_email    = item[0].de_employeeCompanyEmail;
      }
    },
    validatePassword(event){
      const containsUppercase = /[A-Z]/.test(event.target.value);
      const containsLowercase = /[a-z]/.test(event.target.value);
      const containsNumber = /[0-9]/.test(event.target.value);
      const containsSpecial = /[#?!@$%^&*-]/.test(event.target.value);

      if( this.changePass ){
        if( this.form.de_password != ""){
          if( containsUppercase && containsLowercase && containsNumber && containsSpecial ){
            this.okPassword = true;
          }else{
            this.okPassword = false;
          }
        }else{
          this.okPassword = false;
        }
      }
      //return this.okPassword;
    }
  }
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />


    <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <form class="needs-validation" @submit.prevent="saveUser">
              <div class="row">
                <div class="col-lg-4">
                  <h4 class="card-title">Información de Usuario</h4>
                  <div class="row">
                    <div class="col-md-12">
                      <div class="form-group">
                        <label for="de_email">Correo electrónico</label>
                        <input
                          type="email"
                          class="form-control"
                          :class="{ 'is-invalid': submitted && $v.form.de_email.$error }"
                          name="de_email"
                          id="de_email"
                          v-model="form.de_email"
                          value=""
                          placeholder="Correo electrónico de usuario (de la compañía)"
                        >
                        <div v-if="submitted && $v.form.de_email.$error" class="invalid-feedback">
                          <span v-if="!$v.form.de_email.required">Este campo es requerido.</span>
                        </div>
                        <div v-if="$route.params.id">
                          <span>Este campo debe editarse desde el módulo Empleados, editando el empleado al que pertenece este correo.</span>
                        </div>
                      </div>

                      <div class="form-group">
                        <label for="id_role">Rol</label>
                        <select
                          class="form-control"
                          :class="{ 'is-invalid': submitted && $v.form.id_role.$error }"
                          name="id_role"
                          id="id_role"
                          v-model="form.id_role"
                        >
                          <option value="">SELECCIONAR ROL</option>
                          <option v-for="(role, index) in roles" :key="index" :value="role.id_role">{{role.nm_role}}</option>
                        </select>
                        <div v-if="submitted && $v.form.id_role.$error" class="invalid-feedback">
                          <span v-if="!$v.form.id_role.required">Este campo es requerido.</span>
                        </div>
                      </div>

                      <div class="form-group" v-if="$route.params.id || form.id_company != ''">
                        <label for="de_password">Contraseña</label>
                        <input
                          v-model="form.de_password"
                          type="password"
                          name="de_password"
                          class="form-control"
                          :class="{ 'is-invalid': (submitted && $v.form.de_password.$error) || (!okPassword) }"
                          placeholder="Contraseña"
                          v-on:keypress="validatePassword"
                          :disabled="!changePass && !form.id_company"
                        />
                        <div v-if="(submitted && $v.form.de_password.$error) || (!okPassword)" class="invalid-feedback">
                          <span v-if="!$v.form.de_password.required">Este campo es requerido.</span>
                          <span v-if="!$v.form.de_password.minLength">La longitud mínima es de 6 caracteres.</span>
                          <span v-if="!$v.form.de_password.maxLength">La longitud máxima es de 16 caracteres.</span>
                          <span v-if="!okPassword">
                            La contraseña debe contener al menos 1 mayúscula, 1 minúscula, 1 dígito numérico y al menos alguno de los siguientes símbolos: #?!@$%^&*-
                          </span>
                        </div>
                      </div>

                      <div class="form-group" v-if="$route.params.id || form.id_company != ''">
                        <label for="de_password">Repetir contraseña</label>
                        <input
                          v-model="form.de_rePassword"
                          type="password"
                          name="de_rePassword"
                          class="form-control"
                          :class="{ 'is-invalid': submitted && $v.form.de_rePassword.$error }"
                          placeholder="Repetir contraseña"
                          :disabled="!changePass && !form.id_company"
                        />

                        <div
                          v-if="submitted && $v.form.de_rePassword.$error"
                          class="invalid-feedback"
                        >
                          <span v-if="!$v.form.de_rePassword.required">Contraseña requerida.</span>
                          <span
                            v-else-if="!$v.form.de_rePassword.sameAsPassword"
                          >La contraseña no coincide.</span>
                        </div>
                      </div>

                      <div class="form-group" v-if="this.$route.params.id">
                        <b-form-checkbox v-model="changePass" switch class="mb-1">
                          <label>¿Cambiar contraseña?</label>
                        </b-form-checkbox>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="col-lg-8" v-if="!$route.params.id">
                  <h4 class="card-title">Seleccionar empleado a convertir a usuario</h4>
                  
                  <div class="row mt-4">
                    <div class="col-sm-12 col-md-6">
                      <div id="tickets-table_length" class="dataTables_length">
                        <label class="d-inline-flex align-items-center">
                          Mostrar&nbsp;
                          <b-form-select v-model="perPage" size="sm" :options="pageOptions"></b-form-select>&nbsp;registros
                        </label>
                      </div>
                    </div>
                    <!-- Search -->
                    <div class="col-sm-12 col-md-6">
                      <div id="tickets-table_filter" class="dataTables_filter text-md-right">
                        <label class="d-inline-flex align-items-center">
                          Buscar:
                          <b-form-input
                            v-model="filter"
                            type="search"
                            placeholder="Buscar..."
                            class="form-control form-control-sm ml-2"
                          ></b-form-input>
                        </label>
                      </div>
                    </div>
                    <!-- End search -->
                  </div>

                  <!-- Table -->
                  <div class="table-responsive mb-0">
                    <b-table
                      :items="tableData"
                      :fields="fields"
                      responsive="sm"
                      :per-page="perPage"
                      :current-page="currentPage"
                      :sort-by.sync="sortBy"
                      :sort-desc.sync="sortDesc"
                      :filter="filter"
                      :filter-included-fields="filterOn"
                      @filtered="onFiltered"
                      :hover="true"
                      selectable
                      :select-mode="selectMode"
                      @row-selected="onRowSelected"
                    >
                      <template #cell(actions)="{ rowSelected }">
                        <template v-if="rowSelected">
                          <i class="fas fa-check btn-sm btn-primary"></i> <b>SELECCIONADO</b>
                        </template>
                        <template v-else>
                          <i class="fas fa-check btn-sm btn-light"></i>
                        </template>
                      </template>
                      <!--
                      <template v-slot:cell(actions)="row">
                        
                        
                         info(row.item, row.index, $event.target) 
                      </template>
                      -->
                    </b-table>
                  </div>
                  <div class="row">
                    <div class="col">
                      <div class="dataTables_paginate paging_simple_numbers float-right">
                        <ul class="pagination pagination-rounded mb-0">
                          <!-- pagination -->
                          <b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage"></b-pagination>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>

                <!--
                <div class="col-lg-4">
                  <h4 class="card-title">Organizational Data</h4>
                  <div class="row">
                    <div class="col-md-12">
                      <div class="form-group">
                        <label for="id_role">Role</label>
                        <select
                          class="form-control"
                          :class="{ 'is-invalid': submitted && $v.form.id_role.$error }"
                          name="id_role"
                          id="id_role"
                          v-model="form.id_role"
                        >
                          <option value="">SELECT USER ROLE</option>
                          <option v-for="(role, index) in roles" :key="index" :value="role.id_role">{{role.nm_role}}</option>
                        </select>
                        <div v-if="submitted && $v.form.id_role.$error" class="invalid-feedback">
                          <span v-if="!$v.form.id_role.required">Site is required.</span>
                        </div>
                      </div>

                      <div class="form-group">
                        <label for="id_employee">Employee</label>
                        <select
                          class="form-control"
                          :class="{ 'is-invalid': submitted && $v.form.id_employee.$error }"
                          name="id_employee"
                          id="id_employee"
                          v-model="form.id_employee"
                        >
                          <option value="">SELECT EMPLOYEE PROFILE</option>
                          <option v-for="(employee, index) in employees" :key="index" :value="employee.id_employee">{{employee.nm_employee}}</option>
                        </select>
                        <div v-if="submitted && $v.form.id_employee.$error" class="invalid-feedback">
                          <span v-if="!$v.form.id_employee.required">Department is required.</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                -->
              </div>

              <div class="row">
                <div class="col-lg-12 mt-5 pt-5">
                  <div class="form-group text-center">
                    <button class="btn btn-success" type="submit">GUARDAR</button>
                    <router-link to="/company/users" class="ml-3">
                      <button class="btn btn-danger" type="reset">CANCELAR</button>
                    </router-link>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>

  </Layout>
</template>
<style type="text/css">
  .is-invalid  .mx-input{
    border: solid 1px red !important;
  }
  .form-control:disabled{
    background-color: #ecf0f1 !important;
  }
</style>